import { Checkbox } from '@chakra-ui/react'

const CheckboxCell = ({ getValue, row: { index }, column: { id }, table }) => {
  const initialValue = getValue()
  const disabled = table.options.meta?.disabled

  const onChange = (e) => {
    const newValue = e.target.checked

    //React-table v8 will replace . with _
    table.options.meta?.updateData(index, id.replace('__', '._'), newValue)
  }

  return (
    <Checkbox
      borderColor={'gray.400'}
      isChecked={initialValue || false}
      value={initialValue || false}
      onChange={onChange}
      isDisabled={disabled}
    />
  )
}

export default CheckboxCell
